var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValuesIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 148,
    viewBox: "33 9 101 148",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.0006 58.376C96.596 58.376 107.618 47.3515 107.618 33.752C107.618 20.1524 96.5981 9.12793 83.0006 9.12793C69.4031 9.12793 58.3828 20.1524 58.3828 33.752C58.3828 47.3515 69.4052 58.376 83.0006 58.376Z",
    fill: "#FF794E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.244 83.0581C132.244 69.4606 121.219 58.4361 107.622 58.4361H82.9998C55.8027 58.4361 33.7559 80.483 33.7559 107.68V156.924H82.9998V107.68C82.9998 134.877 105.047 156.924 132.244 156.924V107.68H107.636C121.227 107.672 132.244 96.6514 132.244 83.0581Z",
    fill: "#FABBAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.997 108V156.996C132.831 156.998 132.664 157 132.497 157C105.326 157 83.2683 135.108 83 108H132.997Z",
    fill: "#EAB1FC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuesIcon2);
export default __webpack_public_path__ + "static/media/values_icon2.3ccb7f6da2afc99cb05757e4c001a0a3.svg";
export { ForwardRef as ReactComponent };